// extracted by mini-css-extract-plugin
export var actionButton = "_6j-0";
export var attachmentLine = "_6j-1";
export var fileInput = "_6j-2";
export var fileUploadWrapper = "_6j-4";
export var footer = "_6j-3";
export var modalContent = "_6j-5";
export var paperclip = "_6j-6";
export var quillEditor = "_6j-7";